<template>
  <v-snackbar v-model="active" bottom right>
    {{text}}
    <v-btn v-if="to" flat to="to">View</v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'GlobalSnackbar',
  data: function () {
    return {
      text: '',
      to: null,
      active: false
    }
  },
  computed: {
    ...mapGetters([
      'snackbarActive'
    ])
  },
  watch: {
    snackbarActive (newActive) {
      this.text = this.$store.state.snackbarStore.text
      this.to = this.$store.state.snackbarStore.to
      this.active = newActive
    }
  }

}
</script>

<style scoped>

</style>
